import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SessionModel } from '../../models/SessionModel';
import { ApplicationState } from '../../store';
import { ServiceContractModel } from '../../models/ServiceContractModel';
import * as ServContStore from '../../store/ServiceContract';
import { LoadingIcon } from '../Misc/Loading';
import { SaCurrency, SaDate, SaLabel, SaLongText } from '../Misc/SawinComponents';

type MyProps =
    { ServiceContractList: ServContStore.ServiceContractList } & { SessionState: SessionModel } & typeof ServContStore.actionCreators;

class ServiceContractScreen extends React.PureComponent<MyProps> {

    componentDidMount() {
        this.props.loadServiceContract(this.props.SessionState);
    }

    public render() {
        return (
            <Container fluid={true}>
                <LoadingIcon loading={this.props.ServiceContractList.loading} title={this.props.SessionState.SelectedSM.id + " - " + this.props.SessionState.SelectedSM.name.displayName} address={this.props.SessionState.SelectedSM.address} />
                <Col>
                    {this.props.ServiceContractList.items.map((item, index) =>
                        <Row key={index}>
                            <ServiceContractCard item={item} companyCode={this.props.SessionState.SelectedAR.companyCode} ></ServiceContractCard>
                        </Row>
                    )}
                </Col>
            </Container>
        );
    }
}

class ServiceContractCard extends React.PureComponent<{ item: ServiceContractModel, companyCode: string }> {
    
    public render() {
 
        return (<Card className='service-contract-card'>
            <CardHeader>
                <Row>
                    <Col><SaLabel Text={"Contract"} />
                        {this.props.item.id}
                    </Col>
                    <Col className="right-align">
                        <SaLabel Text={"Status"} />
                        {this.props.item.contractStatus}
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col>
                        <SaLabel Text={"Start Date"} /> <SaDate Value={this.props.item.startDate} />
                    </Col>
                    <Col className="right-align">
                        <SaLabel Text={"Expiry"} />  <SaDate Value={this.props.item.expiryDate} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <SaLabel Text={"Amount"} /> <SaCurrency Amount={this.props.item.contractAmount} />
                    </Col>
                    <Col className="right-align">
                        <SaLabel Text={"# of System"} /> {this.props.item.numberOfSystem}
                    </Col>
                </Row>
                <Row>
                    <Col xs="12">
                        <SaLabel Text={"Description"} /> <SaLongText CutTextToPosition={200} OriginalText={this.props.item.contractDescription}/>
                    </Col>                    
                </Row>
            </CardBody>
            <CardFooter>
                <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                    <div>                        
                        <Link to={{ pathname: '/ServiceContractSchedule', state: { contractNumber: this.props.item.id } }}><Button size="sm">Schedule</Button></Link>
                    </div>
                    <div className="center-align">                        
                        <Link to={{ pathname: '/equipment', state: { calledFrom:"CON", source1: this.props.item.id, showButtons:false } }} ><Button size="sm">Equipment</Button></Link>                                                    
                    </div>
                    {this.props.item.allowToRenew && <div className="center-align">
                        <Link to={`/ServiceContractRenew/${this.props.item.id}`}><Button size="sm">Renew</Button></Link>
                    </div>}
                </div>
            </CardFooter>
        </Card>);
    }
}

export default connect(
    (state: ApplicationState) => ({ ...{ ServiceContractList: state.serviceContractState }, ...{ SessionState: state.sessionState } }),
    ServContStore.actionCreators)(ServiceContractScreen as any);
